import { useState, useEffect } from "react";
import { axiosInstance } from "../libries";
import Layout from "../containers/Layout";
import Breadcrumb from "../components/Breadcrumb";
import HelpCenter from "../components/HelpCenter";

const PrivacyPolicy = () => {
  // state to set active tabs
  const [activeHelpTabs, setActiveHelpTabs] = useState("privacy");

  const [privacy, setPrivacy] = useState(null);

  // state to track loading state
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosInstance()
      .get(`/help-center/privacy-policy`)
      .then((resp) => {
        setPrivacy(resp.data.data.message);
      })
      .catch((err) => {
        return err.message;
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    document.title = "ShopNig - Privacy Policy";
  }, []);

  return (
    <Layout>
      <Breadcrumb name="Product detail >" />
      <div className="container">
        <div className="help">
          <HelpCenter
            activeHelpTabs={activeHelpTabs}
            setActiveHelpTabs={setActiveHelpTabs}
          />
          {loading && (
            <div className="loading__spin__address">
              <span className="loader"></span>
            </div>
          )}
          {!loading &&
            privacy?.map((data, i) => (
              <div className="privacy" key={i}>
                <h5 className="privacy__title">{data.title}</h5>
                <div className="privacy__body">
                  {data.description.split("\n\n").map((item, i) => (
                    <p className="text" key={i}>
                      {item}
                    </p>
                  ))}
                  {data.subtitles.map((pri, i) => (
                    <div key={i}>
                      <h1 className="heading">{pri.title}</h1>
                      {pri.description.split("\n").map((item, i) => (
                        <p className="text" key={i}>
                          {item}
                        </p>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            ))}
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPolicy;
